// SEO Landing Pages configuration data
// Each key maps to a route slug

const seoPages = {
  // =================== CITY PAGES ===================
  'moskva': {
    seo: {
      title: 'Хоккейная форма в Москву | Доставка за 2-3 дня | AVK-PRO',
      description: 'Заказать хоккейную форму с доставкой в Москву. Производство в СПб, доставка СДЭК за 2-3 дня. Джерси, гамаши, комплекты для команд. Бесплатная доставка от 50 000 ₽.',
      keywords: 'хоккейная форма москва, хоккейная форма с доставкой в москву, купить хоккейную форму москва, хоккейная экипировка москва',
      canonical: 'https://avk-pro.ru/moskva',
    },
    hero: {
      bg: 'bg-red-900', accent: 'text-red-600',
      subtitle: 'Доставка в Москву и Московскую область',
      title: 'Хоккейная форма в Москву',
      text: 'Производим хоккейную форму в Санкт-Петербурге и доставляем в Москву за 2-3 дня. Работаем с командами любого уровня — от любителей до профессионалов.',
      btnClass: 'bg-white text-red-900 hover:bg-gray-100 font-semibold',
    },
    delivery: {
      title: 'Доставка в Москву', subtitle: 'Несколько вариантов на выбор',
      options: [
        { title: 'СДЭК', time: '2-3 дня', desc: 'Доставка до пункта выдачи или курьером' },
        { title: 'Деловые Линии', time: '2-3 дня', desc: 'Для крупных заказов от 20 кг' },
        { title: 'ПЭК', time: '3-4 дня', desc: 'Экономичная доставка' },
      ],
    },
    advantages: {
      title: 'Почему заказывают у нас из Москвы',
      items: [
        { title: 'Близко к Москве', desc: 'Производство в СПб — ближайший крупный город' },
        { title: 'Доставка 2-3 дня', desc: 'Быстрая отправка СДЭК и Деловыми Линиями' },
        { title: 'Бесплатная доставка', desc: 'При заказе от 50 000 ₽' },
        { title: 'Оплата при получении', desc: 'Работаем с юрлицами по договору' },
      ],
    },
    items: {
      title: 'Кто заказывает форму из Москвы',
      list: ['Любительские хоккейные лиги', 'Корпоративные команды', 'Детские спортивные школы', 'Ночная хоккейная лига', 'Студенческие команды'],
    },
    orderSteps: {
      title: 'Как заказать форму в Москву',
      steps: [
        { title: 'Заявка', desc: 'Оставьте заявку на сайте или позвоните' },
        { title: 'Макет', desc: 'Согласуем дизайн и размеры' },
        { title: 'Производство', desc: 'Изготовим форму за 10-14 дней' },
        { title: 'Доставка', desc: 'Отправим СДЭК за 2-3 дня' },
      ],
    },
    cta: { bg: 'bg-red-600', title: 'Закажите форму с доставкой в Москву', text: 'Бесплатная доставка при заказе от 50 000 ₽' },
  },

  'kazan': {
    seo: {
      title: 'Хоккейная форма в Казань | Доставка 3-4 дня | AVK-PRO',
      description: 'Хоккейная форма с доставкой в Казань и Татарстан. Производство в СПб, доставка за 3-4 дня. Джерси, гамаши для команд.',
      keywords: 'хоккейная форма казань, купить хоккейную форму казань, хоккейная экипировка казань, хоккейная форма татарстан',
      canonical: 'https://avk-pro.ru/kazan',
    },
    hero: {
      bg: 'bg-emerald-800', accent: 'text-emerald-600',
      subtitle: 'Доставка в Казань и Татарстан',
      title: 'Хоккейная форма в Казань',
      text: 'Производим хоккейную форму и доставляем в Казань за 3-4 дня. Работаем с командами Татарстана — родины хоккея!',
      btnClass: 'bg-white text-emerald-800 hover:bg-gray-100 font-semibold',
    },
    delivery: {
      title: 'Доставка в Казань',
      options: [
        { title: 'СДЭК', time: '3-4 дня', desc: 'До пункта выдачи или курьером' },
        { title: 'Деловые Линии', time: '3-4 дня', desc: 'Для крупных заказов' },
        { title: 'ПЭК', time: '4-5 дней', desc: 'Экономичная доставка' },
      ],
    },
    advantages: {
      title: 'Почему заказывают из Казани',
      items: [
        { title: 'Хоккейная столица', desc: 'Понимаем требования казанских команд' },
        { title: 'Быстрая доставка', desc: '3-4 дня до Казани' },
        { title: 'Опыт работы', desc: 'Экипировали 500+ команд по России' },
        { title: 'Качество КХЛ', desc: 'Материалы профессионального уровня' },
      ],
    },
    items: {
      title: 'Кто заказывает из Казани',
      list: ['Команды ночной лиги Казани', 'ДЮСШ Татарстана', 'Корпоративные команды', 'Любительские клубы', 'Студенческие лиги'],
    },
    cta: { bg: 'bg-emerald-700', title: 'Закажите форму в Казань', text: 'Бесплатная доставка от 50 000 руб' },
  },

  'ekaterinburg': {
    seo: {
      title: 'Хоккейная форма в Екатеринбург | Доставка 3-4 дня | AVK-PRO',
      description: 'Хоккейная форма с доставкой в Екатеринбург и Свердловскую область. Производство в СПб, доставка за 3-4 дня.',
      keywords: 'хоккейная форма екатеринбург, купить хоккейную форму екатеринбург, хоккейная экипировка екатеринбург',
      canonical: 'https://avk-pro.ru/ekaterinburg',
    },
    hero: {
      bg: 'bg-orange-800', accent: 'text-orange-600',
      subtitle: 'Доставка в Екатеринбург и Свердловскую область',
      title: 'Хоккейная форма в Екатеринбург',
      text: 'Производим хоккейную форму и доставляем в Екатеринбург за 3-4 дня. Работаем с командами Урала.',
      btnClass: 'bg-white text-orange-800 hover:bg-gray-100 font-semibold',
    },
    delivery: {
      title: 'Доставка в Екатеринбург',
      options: [
        { title: 'СДЭК', time: '3-4 дня', desc: 'До пункта выдачи или курьером' },
        { title: 'Деловые Линии', time: '3-4 дня', desc: 'Для крупных заказов' },
        { title: 'ПЭК', time: '4-5 дней', desc: 'Экономичная доставка' },
      ],
    },
    advantages: {
      title: 'Почему выбирают нас на Урале',
      items: [
        { title: 'Опыт 14+ лет', desc: 'Проверенное качество и сроки' },
        { title: 'От 10 штук', desc: 'Минимальная партия для небольших команд' },
        { title: 'Свой дизайн', desc: 'Разработаем макет бесплатно' },
        { title: 'Гарантия', desc: 'Гарантия на нанесение и швы' },
      ],
    },
    items: {
      title: 'Популярные заказы из Екатеринбурга',
      list: ['Игровые джерси с номерами', 'Тренировочная форма', 'Гамаши в цвет команды', 'Комплекты для ДЮСШ', 'Корпоративная экипировка'],
    },
    cta: { bg: 'bg-orange-700', title: 'Закажите форму в Екатеринбург', text: 'Бесплатная доставка от 50 000 руб' },
  },

  'novosibirsk': {
    seo: {
      title: 'Хоккейная форма в Новосибирск | Доставка 4-5 дней | AVK-PRO',
      description: 'Хоккейная форма с доставкой в Новосибирск и Сибирь. Производство в СПб, доставка за 4-5 дней.',
      keywords: 'хоккейная форма новосибирск, купить хоккейную форму новосибирск, хоккейная экипировка новосибирск, хоккейная форма сибирь',
      canonical: 'https://avk-pro.ru/novosibirsk',
    },
    hero: {
      bg: 'bg-sky-800', accent: 'text-sky-600',
      subtitle: 'Доставка в Новосибирск и Сибирь',
      title: 'Хоккейная форма в Новосибирск',
      text: 'Производим хоккейную форму и доставляем в Новосибирск за 4-5 дней. Работаем с командами Сибири.',
      btnClass: 'bg-white text-sky-800 hover:bg-gray-100 font-semibold',
    },
    delivery: {
      title: 'Доставка в Новосибирск',
      options: [
        { title: 'СДЭК', time: '4-5 дней', desc: 'До пункта выдачи или курьером' },
        { title: 'Деловые Линии', time: '4-5 дней', desc: 'Для крупных заказов' },
        { title: 'ПЭК', time: '5-6 дней', desc: 'Экономичная доставка' },
      ],
    },
    advantages: {
      title: 'Почему заказывают из Новосибирска',
      items: [
        { title: 'Надёжная доставка', desc: 'Проверенные ТК до Сибири' },
        { title: 'Качество', desc: 'Материалы для суровых условий' },
        { title: 'От 10 штук', desc: 'Минимальная партия' },
        { title: 'Индивидуальный дизайн', desc: 'Бесплатная разработка макета' },
      ],
    },
    cta: { bg: 'bg-sky-700', title: 'Закажите форму в Новосибирск', text: 'Бесплатная доставка от 50 000 руб' },
  },

  'chelyabinsk': {
    seo: {
      title: 'Хоккейная форма в Челябинск | Доставка 3-4 дня | AVK-PRO',
      description: 'Хоккейная форма с доставкой в Челябинск и Челябинскую область. Производство в СПб, доставка за 3-4 дня.',
      keywords: 'хоккейная форма челябинск, купить хоккейную форму челябинск, хоккейная экипировка челябинск',
      canonical: 'https://avk-pro.ru/chelyabinsk',
    },
    hero: {
      bg: 'bg-amber-800', accent: 'text-amber-600',
      subtitle: 'Доставка в Челябинск и Челябинскую область',
      title: 'Хоккейная форма в Челябинск',
      text: 'Производим хоккейную форму и доставляем в Челябинск за 3-4 дня. Работаем с командами Южного Урала.',
      btnClass: 'bg-white text-amber-800 hover:bg-gray-100 font-semibold',
    },
    delivery: {
      title: 'Доставка в Челябинск',
      options: [
        { title: 'СДЭК', time: '3-4 дня', desc: 'До пункта выдачи или курьером' },
        { title: 'Деловые Линии', time: '3-4 дня', desc: 'Для крупных заказов' },
        { title: 'ПЭК', time: '4-5 дней', desc: 'Экономичная доставка' },
      ],
    },
    advantages: {
      title: 'Почему мы',
      items: [
        { title: 'Опыт 14+ лет', desc: 'Проверенное качество' },
        { title: 'От 10 штук', desc: 'Минимальная партия' },
        { title: 'Быстро', desc: 'Производство от 10 дней' },
        { title: 'Гарантия', desc: 'На нанесение и швы' },
      ],
    },
    cta: { bg: 'bg-amber-700', title: 'Закажите форму в Челябинск', text: 'Бесплатная доставка от 50 000 руб' },
  },

  'ufa': {
    seo: {
      title: 'Хоккейная форма в Уфу | Доставка 4-5 дней | AVK-PRO',
      description: 'Хоккейная форма с доставкой в Уфу и Башкортостан. Производство в СПб, доставка за 4-5 дней.',
      keywords: 'хоккейная форма уфа, купить хоккейную форму уфа, хоккейная экипировка уфа, хоккейная форма башкортостан',
      canonical: 'https://avk-pro.ru/ufa',
    },
    hero: {
      bg: 'bg-teal-700', accent: 'text-teal-600',
      subtitle: 'Доставка в Уфу и Башкортостан',
      title: 'Хоккейная форма в Уфу',
      text: 'Производим хоккейную форму и доставляем в Уфу за 4-5 дней. Работаем с командами Башкортостана.',
      btnClass: 'bg-white text-teal-700 hover:bg-gray-100 font-semibold',
    },
    delivery: {
      title: 'Доставка в Уфу',
      options: [
        { title: 'СДЭК', time: '4-5 дней', desc: 'До пункта выдачи или курьером' },
        { title: 'Деловые Линии', time: '4-5 дней', desc: 'Для крупных заказов' },
        { title: 'ПЭК', time: '5-6 дней', desc: 'Экономичная доставка' },
      ],
    },
    cta: { bg: 'bg-teal-700', title: 'Закажите форму в Уфу', text: 'Бесплатная доставка от 50 000 руб' },
  },

  // =================== CATEGORY PAGES ===================
  'detskaya-forma': {
    seo: {
      title: 'Детская хоккейная форма на заказ | От 10 комплектов | AVK-PRO СПб',
      description: 'Производство детской хоккейной формы в Санкт-Петербурге. Безопасные материалы, яркий дизайн, размеры от 3 до 16 лет. Форма для ДЮСШ и детских команд от 10 штук.',
      keywords: 'детская хоккейная форма, хоккейная форма для детей, детское хоккейное джерси, форма для детской хоккейной команды',
      canonical: 'https://avk-pro.ru/detskaya-forma',
    },
    hero: {
      bg: 'bg-blue-900', accent: 'text-blue-600',
      badge: 'Для юных чемпионов', badgeBg: 'bg-yellow-500 text-black',
      title: 'Детская хоккейная форма',
      text: 'Профессиональная экипировка для детских хоккейных команд и спортивных школ. Безопасные материалы, точные размеры, яркий индивидуальный дизайн.',
      btnClass: 'bg-yellow-500 hover:bg-yellow-400 text-black font-semibold',
    },
    advantages: {
      title: 'Почему выбирают нашу детскую форму',
      items: [
        { title: 'Безопасные материалы', desc: 'Гипоаллергенные ткани, сертифицированные для детей' },
        { title: 'Точные размеры', desc: 'Размерная сетка от 3 до 16 лет' },
        { title: 'Яркий дизайн', desc: 'Любые цвета и принты для вашей команды' },
        { title: 'Быстрые сроки', desc: 'Изготовление от 7 рабочих дней' },
      ],
    },
    sizes: {
      title: 'Размеры детской хоккейной формы',
      subtitle: 'Таблица размеров по возрасту и росту',
      headers: ['Возраст', 'Рост (см)', 'Обхват груди (см)'],
      rows: [
        ['3-4 года', '98-104', '52-56'], ['5-6 лет', '110-116', '56-60'],
        ['7-8 лет', '122-128', '60-64'], ['9-10 лет', '134-140', '64-68'],
        ['11-12 лет', '146-152', '68-72'], ['13-14 лет', '158-164', '72-76'],
        ['15-16 лет', '170-176', '76-80'],
      ],
    },
    items: {
      title: 'Что входит в комплект детской формы',
      list: ['Игровое джерси с номером', 'Тренировочное джерси', 'Хоккейные гамаши', 'Гетры в цвет команды', 'Повязка капитана (опция)', 'Индивидуальная упаковка'],
    },
    faq: {
      title: 'Частые вопросы о детской форме',
      items: [
        { q: 'Какой минимальный заказ детской формы?', a: 'Минимальная партия — 10 комплектов. Это позволяет экипировать небольшую детскую команду.' },
        { q: 'Можно ли заказать форму с именем и номером ребенка?', a: 'Да, мы наносим имена, фамилии и номера на каждый комплект. Используем износостойкую сублимационную печать.' },
        { q: 'Сколько времени занимает изготовление?', a: 'Стандартный срок — 10-14 рабочих дней. Срочный заказ — от 7 дней (доплата 20%).' },
        { q: 'Как правильно выбрать размер для ребенка?', a: 'Ориентируйтесь на рост и обхват груди. Если ребенок между размерами — берите больший, дети быстро растут.' },
      ],
    },
    cta: { bg: 'bg-blue-900', title: 'Закажите детскую форму для вашей команды', text: 'Оставьте заявку и получите расчет стоимости в течение 30 минут' },
  },

  'nochnaya-liga': {
    seo: {
      title: 'Хоккейная форма для ночной лиги | Любительский хоккей | AVK-PRO',
      description: 'Хоккейная форма для ночной хоккейной лиги и любительских команд. Яркий дизайн, качественные материалы, доступные цены. От 10 комплектов.',
      keywords: 'хоккейная форма для ночной лиги, любительская хоккейная форма, форма НХЛ любители',
      canonical: 'https://avk-pro.ru/night-league',
    },
    hero: {
      bg: 'bg-gray-900', accent: 'text-yellow-500',
      title: 'Хоккейная форма для ночной лиги',
      text: 'Экипируем любительские команды ночных хоккейных лиг. Яркий дизайн, отличное качество, честные цены.',
      btnClass: 'bg-yellow-500 text-black hover:bg-yellow-400 font-semibold',
    },
    advantages: {
      title: 'Почему мы подходим для ночных лиг',
      items: [
        { title: 'Для любителей', desc: 'Понимаем специфику ночных лиг' },
        { title: 'Яркий дизайн', desc: 'Любые цвета и принты' },
        { title: 'Быстро', desc: 'Изготовление от 10 дней' },
        { title: 'Удобная оплата', desc: 'Карта, наличные, рассрочка' },
      ],
    },
    items: {
      title: 'Что заказывают команды НХЛ', iconClass: 'text-yellow-500',
      list: ['Игровые джерси с номерами', 'Запасные комплекты (свет/тьма)', 'Тренировочные манишки', 'Гамаши в цвет команды', 'Командные гетры', 'Баннер и атрибутика'],
    },
    cta: { bg: 'bg-gray-900', title: 'Готовы выйти на лёд в новой форме?', text: 'Расчёт стоимости за 30 минут', btnClass: 'bg-yellow-500 text-black hover:bg-yellow-400 font-semibold' },
  },

  'korporativnye-komandy': {
    seo: {
      title: 'Хоккейная форма для корпоративных команд | AVK-PRO',
      description: 'Хоккейная форма для корпоративных команд и турниров. Нанесение логотипа компании, брендирование. От 10 комплектов.',
      keywords: 'корпоративная хоккейная форма, хоккейная форма для компании, корпоративный хоккей, форма с логотипом компании',
      canonical: 'https://avk-pro.ru/corporate',
    },
    hero: {
      bg: 'bg-slate-800', accent: 'text-blue-500',
      title: 'Хоккейная форма для корпоративных команд',
      text: 'Экипируем корпоративные хоккейные команды. Нанесение логотипа компании, фирменные цвета, профессиональное качество.',
      btnClass: 'bg-blue-500 hover:bg-blue-400 text-white font-semibold',
    },
    advantages: {
      title: 'Почему компании выбирают нас',
      items: [
        { title: 'Корпоративный стиль', desc: 'Точное воспроизведение фирменных цветов и логотипов' },
        { title: 'Работа с юрлицами', desc: 'Договор, счёт, акты, НДС' },
        { title: 'Быстро', desc: 'Производство от 10 рабочих дней' },
        { title: 'Любой объём', desc: 'От 10 до 1000+ комплектов' },
      ],
    },
    items: {
      title: 'Что заказывают корпоративные команды',
      list: ['Игровые джерси с логотипом', 'Тренировочную форму', 'Гамаши и гетры', 'Сувенирные джерси для руководства', 'Форму для турниров', 'Баннеры и атрибутику'],
    },
    cta: { bg: 'bg-slate-800', title: 'Закажите форму для вашей компании', text: 'Работаем по договору с юрлицами' },
  },

  'dyush': {
    seo: {
      title: 'Хоккейная форма для ДЮСШ | Спортивные школы | AVK-PRO',
      description: 'Хоккейная форма для детско-юношеских спортивных школ. Качественные материалы, доступные цены, размеры для всех возрастов.',
      keywords: 'хоккейная форма ДЮСШ, форма для спортивной школы, хоккейная форма для юниоров, детская хоккейная экипировка',
      canonical: 'https://avk-pro.ru/dyush',
    },
    hero: {
      bg: 'bg-indigo-900', accent: 'text-indigo-500',
      badge: 'Для спортивных школ', badgeBg: 'bg-yellow-500 text-black',
      title: 'Хоккейная форма для ДЮСШ',
      text: 'Экипируем детско-юношеские спортивные школы. Качественные безопасные материалы, размерный ряд для всех возрастов.',
      btnClass: 'bg-yellow-500 hover:bg-yellow-400 text-black font-semibold',
    },
    advantages: {
      title: 'Преимущества для ДЮСШ',
      items: [
        { title: 'Безопасные материалы', desc: 'Сертифицированные ткани для детей' },
        { title: 'Все размеры', desc: 'От 3 до 18 лет' },
        { title: 'Скидки ДЮСШ', desc: 'Специальные цены для спортшкол' },
        { title: 'Работа по договору', desc: 'Полный пакет документов' },
      ],
    },
    items: {
      title: 'Что заказывают спортшколы',
      list: ['Игровые комплекты на сезон', 'Тренировочные майки', 'Парадную форму', 'Гамаши и гетры', 'Вратарские комплекты', 'Атрибутику для болельщиков'],
    },
    cta: { bg: 'bg-indigo-900', title: 'Экипируйте вашу спортшколу', text: 'Специальные условия для ДЮСШ' },
  },

  // =================== PRODUCT PAGES ===================
  'gamashi': {
    seo: {
      title: 'Хоккейные гамаши на заказ | Гамаши для команд | AVK-PRO',
      description: 'Производство хоккейных гамашей на заказ. Сублимационная печать, любые цвета и дизайн. Гамаши для хоккейных команд от 10 пар.',
      keywords: 'хоккейные гамаши, гамаши на заказ, хоккейные гамаши с печатью, купить хоккейные гамаши',
      canonical: 'https://avk-pro.ru/gamashi',
    },
    hero: {
      bg: 'bg-violet-900', accent: 'text-violet-500',
      title: 'Хоккейные гамаши на заказ',
      text: 'Производим хоккейные гамаши с индивидуальным дизайном. Сублимационная печать, износостойкие материалы, точный крой.',
      btnClass: 'bg-white text-violet-900 hover:bg-gray-100 font-semibold',
    },
    advantages: {
      title: 'Почему наши гамаши',
      items: [
        { title: 'Сублимация', desc: 'Стойкая печать, не выгорает и не стирается' },
        { title: 'Точный крой', desc: 'Сидят как влитые, не сползают' },
        { title: 'Прочные', desc: 'Выдерживают активную игру' },
        { title: 'Любой дизайн', desc: 'Цвета команды, логотипы, паттерны' },
      ],
    },
    items: {
      title: 'Варианты гамашей',
      list: ['Игровые гамаши (матчевые)', 'Тренировочные гамаши', 'Гамаши с номером', 'Гамаши с логотипом спонсора', 'Детские гамаши', 'Вратарские гамаши'],
    },
    cta: { bg: 'bg-violet-900', title: 'Закажите гамаши для вашей команды', text: 'Минимальная партия — 10 пар' },
  },

  'optom': {
    seo: {
      title: 'Хоккейная форма оптом | От производителя | AVK-PRO',
      description: 'Хоккейная форма оптом от производителя в Санкт-Петербурге. Скидки от 20% на крупные партии. Джерси, гамаши, комплекты.',
      keywords: 'хоккейная форма оптом, хоккейная форма от производителя, оптовая хоккейная форма, хоккейная форма оптом цена',
      canonical: 'https://avk-pro.ru/optom',
    },
    hero: {
      bg: 'bg-green-900', accent: 'text-green-500',
      badge: 'Скидки до 30%', badgeBg: 'bg-green-500 text-white',
      title: 'Хоккейная форма оптом',
      text: 'Производим хоккейную форму оптом. Выгодные цены для крупных заказов: лиг, федераций, сетей магазинов. Скидки от 20% на партии от 50 комплектов.',
      btnClass: 'bg-green-500 hover:bg-green-400 text-white font-semibold',
    },
    advantages: {
      title: 'Условия оптовых заказов',
      items: [
        { title: 'От 50 комплектов', desc: 'Скидка 20% от розничной цены' },
        { title: 'От 100 комплектов', desc: 'Скидка 25% + бесплатная доставка' },
        { title: 'От 200 комплектов', desc: 'Скидка 30% + персональный менеджер' },
        { title: 'Работа по договору', desc: 'Полный пакет документов, НДС' },
      ],
    },
    items: {
      title: 'Кто заказывает оптом',
      list: ['Хоккейные лиги и федерации', 'Сети спортивных магазинов', 'Организаторы турниров', 'Спортивные школы', 'Дилеры и дистрибьюторы', 'Корпоративные закупщики'],
    },
    faq: {
      title: 'Вопросы по оптовым заказам',
      items: [
        { q: 'Какая минимальная партия для опта?', a: 'Оптовые скидки начинаются от 50 комплектов. Но мы работаем и с меньшими заказами от 10 штук.' },
        { q: 'Можно ли разные дизайны в одном заказе?', a: 'Да, вы можете комбинировать дизайны. Каждый дизайн — от 10 штук.' },
        { q: 'Какие сроки оптовых заказов?', a: 'Стандартный срок — 14-21 рабочий день. Зависит от объёма и сложности дизайна.' },
      ],
    },
    cta: { bg: 'bg-green-800', title: 'Запросите оптовый прайс', text: 'Ответим в течение 2 часов' },
  },
  'jersey': {
    seo: {
      title: 'Хоккейное джерси на заказ | AVK-PRO',
      description: 'Изготовление хоккейного джерси на заказ с логотипом и номером. Сублимационная печать, любой дизайн. Производство от 1 штуки. Срок 7-14 дней.',
      keywords: 'хоккейное джерси на заказ, джерси с логотипом, хоккейная майка на заказ, сублимационное джерси, хоккейная форма джерси',
      canonical: 'https://avk-pro.ru/jersey',
    },
    hero: {
      title: 'Хоккейное джерси на заказ',
      subtitle: 'Любой дизайн, любые цвета. Ваш логотип и номер — за 7-14 дней.',
      btnText: 'Заказать джерси',
    },
    advantages: {
      title: 'Почему выбирают наше джерси',
      items: [
        { title: 'Сублимационная печать', desc: 'Цвета не выгорают и не трескаются даже после сотен стирок' },
        { title: 'Любой дизайн', desc: 'Ваш логотип, номер, фамилия — воплотим любую идею' },
        { title: 'От 1 штуки', desc: 'Нет минимального заказа — шьём даже единичные экземпляры' },
        { title: 'Срок 7-14 дней', desc: 'Быстрое производство без потери качества' },
      ],
    },
    items: {
      title: 'Виды джерси',
      list: ['Игровое джерси', 'Тренировочное джерси', 'Джерси вратаря', 'Джерси с вышивкой', 'Детское джерси', 'Женское джерси'],
    },
    cta: { bg: 'bg-blue-800', title: 'Получите расчёт стоимости джерси', text: 'Ответим в течение 1 часа' },
  },
  'trenirovochnaya-forma': {
    seo: {
      title: 'Тренировочная форма для хоккея | AVK-PRO',
      description: 'Производство тренировочной формы для хоккея на заказ. Удобная, прочная, с вашим логотипом. Для команд, школ, секций. Срок от 10 дней.',
      keywords: 'тренировочная форма для хоккея, хоккейная тренировочная форма на заказ, тренировочный комплект хоккей, форма для тренировок',
      canonical: 'https://avk-pro.ru/trenirovochnaya-forma',
    },
    hero: {
      title: 'Тренировочная форма для хоккея',
      subtitle: 'Удобная и прочная форма для тренировок с вашим логотипом. Для команд, школ и секций.',
      btnText: 'Заказать форму',
    },
    advantages: {
      title: 'Преимущества тренировочной формы AVK-PRO',
      items: [
        { title: 'Функциональный крой', desc: 'Свобода движений при катании и силовой борьбе' },
        { title: 'Износостойкие материалы', desc: 'Форма выдерживает интенсивные ежедневные тренировки' },
        { title: 'Брендирование команды', desc: 'Логотип, номера, фамилии — полный комплект идентификации' },
        { title: 'Комплектные заказы', desc: 'Одинаковая форма для всей команды с доставкой' },
      ],
    },
    items: {
      title: 'Состав тренировочного комплекта',
      list: ['Тренировочное джерси', 'Тренировочные шорты', 'Компрессионное бельё', 'Тренировочные носки', 'Куртка разминочная', 'Штаны спортивные'],
    },
    cta: { bg: 'bg-red-800', title: 'Закажите тренировочную форму', text: 'Рассчитаем стоимость для вашей команды' },
  },
};

export default seoPages;
